export default __webpack_public_path__ + "static/media/screen_google_sheets_05.d8d6a2dd.png";